li.profile {
  &::before {
    content: none !important;
  }
  display: flex;
  align-items: center;
  gap: 20px;
  font-weight: 600;
  color: var(--sdx-color-sc-navy);
  padding-bottom: 22px;
  margin-bottom: 22px;
  border-bottom: 1px solid var(--sdx-color-gray-tint-8);
  > .name {
    display: flex;
    flex-direction: column;
  }
  > sdx-icon {
    font-size: 32px;
    width: 1.40625em;
    height: 1.40625em;
    border-radius: 50%;
    background-color: var(--sdx-color-aluminum);
    text-align: center;
    padding-top: 0.2em;
  }
}
